<template>
  <div class="w-100 mt-5">
    <!-- <div class="alert alert-warning" role="alert" v-show="showAlert">
      {{ showMessage }}
    </div> -->
    <div class="row bg-white">
      <div class="text-start p-3 m-2" style="width:80%">
        <label class="font-bold text-lg text-title">Banner Set Up</label>
        <hr />
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">Banner Name </label>
          <div class="col-sm-10">
            <CustomInput
              type="text"
              placeholder="Enter Name"
              :inputClass="'fw-bold'"
              :value="banner_name"
              @onChange="(value) => (banner_name = value)"
              maxlength="32"
              :lengthIndicator="true"
              :error="errors.banner_name"
            />
          </div>
        </div>
				<div class="mb-3 row">
          <label class="col-sm-2 col-form-label">Image Banner </label>
          <input type="hidden" v-model="banner_image">
          <div class="col-sm-10">
						<div class="row">
							<div class="col-auto">
                      
								<img v-if="!banner_image_url" src="@/assets/images/ic_add_icon.png" width="280" height="110" @click="$refs.banner.click()"/>
                <img v-else :src="banner_image_url" width="280" height="110"/>
                <input
                  type="file"
                  ref="banner"
                  name="banner"
                  style="display: none"
                  accept="image/*"
                  v-on:change="onChangeimageBanner()"
                />
                <div class="text-danger error-text fw-bold" v-if="errors.banner_image_url">{{errors.banner_image_url}}</div>
                <div v-if="banner_image_url" class="mt-4 " @click="$refs.banner.click()"> 
                  <button class="p-2 shadow-sm btn-change-image">
                    <img src="@/assets/ic_edit.svg" alt="edit" width="16" height="16"/> Change
                  </button>
                </div>
							</div>
							<div class="col-sm-6">
                <div class="row">
                  <div class="col-1">
                    <img src="@/assets/images/ic_alert.png" width="16" height="16" class="mb-4" > 
                  </div>
                  <div class="col-11">
                    <span>Upload <strong>PNG or JPG</strong> extension with dimension <strong> 1000 x 500 px </strong></span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <img src="@/assets/images/ic_alert.png" width="16" height="16" class="mb-4" > 
                  </div>
                  <div class="col-11">
                    <span>File size can not exceed <strong>2 MB</strong></span>
                  </div>
                </div>
							</div>
						</div>
           
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-2 col-form-label">Banner URL </label>
          <div class="col-sm-10">
            <CustomInput
              type="text"
              placeholder="Example https://paxel.co"
              :inputClass="'fw-bold'"
              :value="banner_url"
              @onChange="(value) => (banner_url = value)"
              maxlength="255"
              :error="errors.banner_url"
            />
          </div>
        </div>
        <label class="font-bold text-lg text-title">Displayed In</label>
        <hr />
				<div class="row mb-4" v-for="(v, i) in displayed_in" :key="i">
					<div class="col-sm-2">
						<label class="required" >Value*</label>
					</div>
					<div class="col-sm-8">
						<CustomInput
              @input="displayed_in[i] = $event.target.value"
              :value ="v"
              type="text"
              placeholder="Enter Value"
              :inputClass="'fw-bold'"
              maxlength="255"
            />
          <div class="text-danger error-text fw-bold py-2" v-if="errors.displayed_in && displayed_in[i]==''">{{errors.displayed_in}}</div>
					</div>
					<div class="col-sm-2">
						<a @click="deleteRow(i)" class="ms-2 me-2" v-if="displayed_in.length > 1" >
							<img src="@/assets/images/ic_delete.png" width="24" height="24" />
						</a>
						<div class="btn" style="background-color:#F3F2F8;color:#5E50A1" v-if="displayed_in.length-1 == i" @click="addRow()">+ Add</div>
					</div>
				</div>
        <div class="mt-6 d-flex justify-content-end">
          <button
            style="margin-right:10px"
            type="button"
            class="btn btn-link shadow-sm rounded text-uppercase rounded text-danger border border-danger text-decoration-none px-4 py-3 fw-bold"
            @click="backToBanner()"
          >
            DISCARD
          </button>
          <button
            type="button"
            class="btn btn-danger text-white shadow-sm rounded px-4 py-3 fw-bold"
            @click="submitData()"
          >
            SAVE BANNER
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput.vue";
 export default {
			components: {
				CustomInput,
			},
      data() {
        return {
					banner_name:"",
					banner_url:"",
					banner_image_url:"",
					banner_image:"",
					id:"",
					url:"",
					errors :{},
					displayed_in :[''],
					width:"",
					height:"",
				}
			},
      mounted(){
      var currentUrl = this.$route.path.split("/");
        this.id = currentUrl[currentUrl.length - 1];
        this.url = currentUrl[currentUrl.length - 2]
        if (this.url == "edit") {
          this.getOne()
        }
      },
			methods:{
				handleValidation() {
					let errors = {};
					if (!this.banner_name) errors.banner_name = "Banner name cannot be empty";
					if (!this.banner_url) errors.banner_url = "Banner url cannot be empty";
					if (!this.banner_image_url) errors.banner_image_url = "Banner image cannot be empty";
          for (let i = 0; i < this.displayed_in.length; i++) {
            if (!this.displayed_in[i]) errors.displayed_in = "Value cannot be empty";
          }
					if (Object.keys(errors).length) {
						this.errors = errors;
						return false;
					} else {
						this.errors = {};
					}
					return true;
				},
				addRow(){
					this.displayed_in.push('')
				},
				deleteRow(i){
					this.displayed_in.splice(i,1);
				},
        
        async onChangeimageBanner() {
          const input = this.$refs.banner;
          const { files } = input;
          const file = files[0];

          if(!file) return
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = e => {
            const src = e.target.result;
            const img = new Image();
            img.onload = () => {
              this.width = img.width
              this.height = img.height
              let extension = file.type.split("/").pop().toLowerCase();
              let allowed_image = ['jpg','png','jpeg']
              if(!allowed_image.includes(extension)){
                this.$swal({
                  title: "Image format not supported",
                  icon: "warning",
                  timer: 2000,
                })
                input.value = null; //reset image for handle same image input twice not return error
              }else if (file.size > 2048000) {
                this.$swal({
                  title: "Size Image Too Large",
                  icon: "warning",
                  timer: 2000,
                })
                input.value = null; //reset image for handle same image input twice not return error
              } else if (this.width < 1000 || this.height*2 != this.width) {
                this.showAlert = true
                this.$swal({
                  title: "Width And Height resolution less than 1000x500 or ratio not 2:1",
                  icon: "warning",
                  timer: 2000,
                })
                input.value = null; //reset image for handle same image input twice not return error
              } else {
                this.banner_image_url = URL.createObjectURL(file);
                this.banner_image = file;
                input.value = null;
              }
            };
            img.src = src
          }
        },
        async submitData(){
          if(this.handleValidation()){
            let body = new FormData();
            // let file = event.target.files[0];
            body.append("banner_name", this.banner_name);
            body.append("banner_url", this.banner_url);
            body.append("image_banner", this.banner_image);
            for (let i = 0; i < this.displayed_in.length; i++) {
              body.append('displayed_in[]', this.displayed_in[i]);
            }
            if (this.url == "edit") {
              let payload = {
                id : this.id,
                body : body,
              }
              try {
                this.$store.dispatch("setLoadingGlobal", true)
                await this.$store.dispatch("banner/updateBanner", payload)
                this.$router.push("/marketing/banners");

              } catch (error) {
                this.$swal({
                  title: error.response?.data?.errorMessage || error.message,
                  icon: "warning",
                  timer: 2000,
                })
              }finally{
                this.$store.dispatch("setLoadingGlobal", false)
              }
            }else{
              try {
                this.$store.dispatch("setLoadingGlobal", true)
                await this.$store.dispatch("banner/createBanner", body)
                this.$router.push("/marketing/banners");

              } catch (error) {
                this.$swal({
                  title: error.response?.data?.errorMessage || error.message,
                  icon: "warning",
                  timer: 2000,
                })
              }finally{
                this.$store.dispatch("setLoadingGlobal", false)
              }
            }
          }
        },
        async getOne() {
          try {
            this.$store.dispatch("setLoadingGlobal", true)
            let data = await this.$store.dispatch("banner/getOneBanner", this.id)
            this.banner_name = data.item.banner_name
            this.banner_url = data.item.banner_url
            this.banner_image_url = data.item.image_url
            this.displayed_in = data.item.displayed_in

          } catch (error) {
            this.$swal({
              title: error.response?.data?.errorMessage || error.message,
              icon: "warning",
              timer: 2000,
            })
          }finally{
            this.$store.dispatch("setLoadingGlobal", false)
          }
        },
        backToBanner(){
          this.$router.push("/marketing/banners");
        },
			},
 }
</script>

<style>
  .btn-change-image{
    border : 1px solid #E0E3EC;
    background-color: white ;
    color: #5E50A1;
    border-radius: 5px;
  }
  .text-title{
    color:#424143;
    font-size: 14px;
    font-weight: bold;
  }
</style>